// src/components/InvoiceModal.js
import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button, Grid } from "@mui/material";
import { createInvoice } from "../../services/invoiceService";
import { ColorModeContext, tokens } from "../../theme";
import InvoiceTable from "./InvoiceTable";
const Invoice = ({ open, handleClose, patient }) => {
  return (
    <Box>
      <InvoiceTable />
    </Box>
  );
};

export default Invoice;
